// @ts-ignore
import baguetteBox from 'baguettebox.js';

export default () =>
    baguetteBox.run('.baguettebox--open', {
        noScrollbars: true,
        async: true,
        titleTag: true
    });
